import React from 'react'
import SummaryHeader from './SummaryHeader'
import CalendarTimelineItems from '../common_components/CalendarTimelineItems'

class SummaryDetail extends React.Component {

  showDetailOnViewport () {
    const windowH = $(window).height()
    const scrollTop = $(window).scrollTop()
    const detailH = $('.summary-detail').height()
    const detailTop = $('.summary-detail').offset().top
    let requiredTop = null
    if (detailTop - 120 - 80 < scrollTop) {
      requiredTop = detailTop - 150 - 80
      $(window).scrollTop(requiredTop)
    } else if (detailTop + detailH > scrollTop + windowH) {
      requiredTop = detailTop + detailH - (scrollTop + windowH) + 120 + 80
      $(window).scrollTop(requiredTop)
    }
  }

  onHelpfulCheck (data) {
    this.props.onHelpfulCheck(this.props.summaryData.date, data)
  }

  componentDidMount () {
    this.showDetailOnViewport()
  }

  componentDidUpdate () {
    this.showDetailOnViewport()
  }

  render () {
    return (
      <div className='summary-detail'>
        <SummaryHeader
          date={this.props.summaryData.date}
          benefits={this.props.summaryData.data.benefit_events}
          handleItemClick={this.props.handleItemClick}
          display_modal={this.props.display_modal}
          onHelpfulCheck={this.props.onHelpfulCheck}
          handleJustLookingClick={this.props.handleJustLookingClick}
        />
        <CalendarTimelineItems
          timeline_events={this.props.summaryData.data.timeline_events}
          manageTimelineData={this.props.manageTimelineData}
          handleItemClick={this.props.handleItemClick}
          display_modal={this.props.display_modal}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          handleJustLookingClick={this.props.handleJustLookingClick}
          show_hidden_tasks={this.props.show_hidden_tasks}
          handleCustomTaskDelete={this.props.handleCustomTaskDelete}
          handleCustomTaskClick={this.props.handleCustomTaskClick}
          custom_task_modal={this.props.custom_task_modal}
          handleCustomTaskChange={this.props.handleCustomTaskChange}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      </div>
    )
  }
}

export default SummaryDetail;